import { CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { SessionLoader } from "./Components/Auth/SessionLoader";

function App() {
  return (
    <SessionLoader>
      <div className="app-main">
        <CssBaseline />
        <RouterProvider router={routes} fallbackElement={<div>Loading...</div>} />
        <ToastContainer />
      </div>
    </SessionLoader>
  );
}

export default App;
